import * as types from 'src/store/mutation-types'
import { CompanyClient } from 'src/api/Companies'

const actions = {
  createCompany ({ commit }, company) {
    return new CompanyClient()
      .create(company)
      .then(company => {
        company = company.data.data
        company.type = 'company'
        commit(types.ADD_CUSTOMER, company)
        return company
      })
  },

  updateCompany ({ commit }, data) {
    return new CompanyClient()
      .include(['default_email_address', 'default_phone_number'])
      .update(data.id, data)
      .then(company => {
        company = company.data.data
        company.type = 'company'
        commit(types.UPDATE_CUSTOMER, company)
        return company
      })
  }
}

export default {
  actions
}
